"use client";

import { useEffect, useState } from "react";
import { HelpCenterTour, isHelpCenterTourCompleted, restartHelpCenterTour } from "@/components/tour/help-center-tour";
import { TourIndicator } from "@/components/tour/tour-indicator";

export function HelpCenterTourWrapper() {
  const [shouldRunTour, setShouldRunTour] = useState(false);
  const [showIndicator, setShowIndicator] = useState(false);

  useEffect(() => {
    const tourCompleted = isHelpCenterTourCompleted();

    if (!tourCompleted) {
      const timer = setTimeout(() => {
        setShouldRunTour(true);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      const indicatorTimer = setTimeout(() => {
        setShowIndicator(true);
      }, 2000);
      return () => clearTimeout(indicatorTimer);
    }
  }, []);

  const handleRestartTour = () => {
    setShowIndicator(false);
    restartHelpCenterTour();
  };

  return (
    <>
      <HelpCenterTour
        shouldRun={shouldRunTour}
        onComplete={() => setShouldRunTour(false)}
      />
      {showIndicator && (
        <TourIndicator
          tourName="Help Center Tour"
          description="Discover help articles, AI chat assistant, and support resources"
          onRestart={handleRestartTour}
          position="bottom-right"
          icon="sparkles"
        />
      )}
    </>
  );
}
